"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const common_1 = require("@finley-technologies/common");
/**
 * Simple pointer method that ensures there are at least a unique number of company names.
 * If not, then simply kickout everything.
 */
const uniqueCompanyNamesLimitPointer = (params) => {
    const { concentrationReceivables, valueConfig, totalConcentrationExposure, } = params;
    // *** Set up hardcoded values ***
    const baseFieldCompanyName = 'company_ing_dba';
    // *** Set up recording variables ***
    const uniqueCompanyNames = new Set();
    // *** Manage calculations by looping through each receivable ***
    const targetReceivables = [];
    for (const receivable of concentrationReceivables) {
        const { finleyReceivableId, baseFields, eligibilityFields } = receivable;
        // We only care about eligible receivables
        if (!eligibilityFields.isEligible)
            continue;
        const companyName = baseFields[baseFieldCompanyName];
        (0, common_1.finleyAssert)(typeof companyName === 'string', `capitalSouthwestCorporationIngCapital1.uniqueCompanyNamesLimitPointer: Incurred unsupported name base field value [key:${baseFieldCompanyName}] [receivableId:${finleyReceivableId}]`);
        uniqueCompanyNames.add(companyName);
        targetReceivables.push(receivable);
    }
    if (uniqueCompanyNames.size >= valueConfig.limit) {
        return {
            kickouts: {},
            calculations: {
                concentrationLimit: valueConfig.limit,
                concentrationAmount: totalConcentrationExposure,
                concentration: uniqueCompanyNames.size,
            },
        };
    }
    // *** Manage kickout calculations ***
    const kickouts = {};
    for (const receivable of targetReceivables) {
        const { finleyReceivableId, concentrationLimitFields } = receivable;
        kickouts[finleyReceivableId] =
            concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts;
    }
    return {
        kickouts,
        calculations: {
            concentrationLimit: valueConfig.limit,
            concentrationAmount: totalConcentrationExposure,
            concentration: uniqueCompanyNames.size,
        },
    };
};
exports.concentrationLimitPointerMethods = [
    {
        method: 'capitalSouthwestCorporationIngCapital1.uniqueCompanyNamesLimit',
        pointerImplementation: uniqueCompanyNamesLimitPointer,
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map